import React from 'react'
import { withRouter } from 'react-router-dom'
import AuthenticationService from '../../app/service/authenticationService'
import { messageError } from '../../components/toastr'
import { AuthContext } from '../../main/authenticationProvider'
import { Card, Input, Button, Form } from 'antd';
import { LoginOutlined } from '@ant-design/icons';
import styles from './login.module.scss';

class Login extends React.Component {

    state = {
        username: '',
        password: ''
    }

    constructor() {
        super();
        this.authenticationService = new AuthenticationService();
    }

    enter = () => {
        this.authenticationService.login({
            username: this.state.username,
            password: this.state.password
        }).then(response => {

            if (response.data.status !== 200) {
                messageError(response.data.message)
            } else {
                this.context.startSession(response);
                response.data.data.mgmt ? this.props.history.push('/mgmt') : this.props.history.push('/');
            }
        }).catch(error => {
            if (error.response) {
                messageError(error.response.data.message)
            }
        })
    }

    render() {
        return (
            <div className={styles['background']}>
                <Card className={styles['loginCard']} title="Login">
                    <Form
                        name="login"
                        layout='vertical'
                        onFinish={this.enter}
                        // onFinishFailed={onFinishFailed}
                        autoComplete="off"
                    >
                        <Form.Item
                            label="Username"
                            name="username"
                            rules={[{ required: true, message: 'Favor inserir o usuário.' }]}
                        >

                            <Input placeholder='Type the username' value={this.state.username} onChange={e => this.setState({ username: e.target.value })} />
                        </Form.Item>
                        <Form.Item
                            label="Password"
                            name="password"
                            rules={[{ required: true, message: 'Favor inserir a senha.' }]}
                        >
                            <Input.Password placeholder='Type the password' value={this.state.password} onChange={e => this.setState({ password: e.target.value })} />
                        </Form.Item>
                        <Form.Item>
                            <Button
                                htmlType="submit"
                                type='primary'
                                style={{ backgroundColor: '#246192', marginTop: '20px' }}
                                icon={<LoginOutlined />}
                                children='Enter'
                                block
                            />
                        </Form.Item>
                    </Form>
                </Card>
            </div>
        )
    }
}

Login.contextType = AuthContext

export default withRouter(Login)